<template>
	<div class="text-center margin-top-30" v-if="display">
		<h4>No Results Found</h4>
		<p class="no-margin-top">There are no {{ type }} that match your current search criteria.</p>
	</div>
</template>
<script>
/**
 * No Results module is used to display a 'No Results' message in a dashboard component
 * @class NoResults
 * @prop {boolean} show - Used to determine whether or not the no results component should be shown
 * @prop {string} type - Used to determine the type to display in the message (default: `results`)
 * @since 0.0.4
 */

export default {
	name: 'no-results',
	props: {
		show: {
			default: false
		},
		type: {
			default: 'results'
		}
	},
	data () {
		return {
			display: false
		}
	},
	/**
	 * Run on `created` to set the display variable equal to the show value
	 * @function
	 * @return {undefined}
	 * @memberof NoResults
	 * @version 0.0.4
	 */
	created () {
		this.display = this.show
	},
	watch: {
		/**
		 * Watch `show` value to determine whether to display the message or not
		 * @function
		 * @param {boolean} val - The current value of this.show
		 * @return {undefined}
		 * @memberof NoResults
		 * @version 0.0.4
		 */
		show (val) {
			if (val) {
				this.display = true
			} else {
				this.display = false
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// NoResults.vue?5137da40